export const CONSTS = {
  DO_NOT_PROCESS_HEADER: $localize`Notice`,
  DO_NOT_PROCESS_BODY: $localize`Return to UPS!`.toUpperCase(),
  DO_NOT_PROCESS_BODY_2: $localize`Do not process the following packages:`,
  OK: $localize`Ok`,
};
